module.exports = __webpack_public_path__ + "static/media/artist-rush-album-12.ba4a3bd3.jpg";